/**
 * Developer-only pages (MOM, Data Analysis, B27 Regime) — hidden on the public URL only.
 */
const PUBLIC_HOSTS = new Set(['ucii.ceas5.uc.edu', 'www.ucii.ceas5.uc.edu']);

export function isInternalPagesHost() {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname.toLowerCase();
  if (PUBLIC_HOSTS.has(host)) {
    return false;
  }
  if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]') {
    return true;
  }
  // Lab workstation / private network (e.g. http://10.39.8.190:3000 or :3001)
  return /^(10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)/.test(host);
}
